import { ManualBankAccountValues } from "types/Models/manualBankAccount";
import { SensitiveDataFormField } from "types/Models/sensitiveData";
import { isSensitiveDataFieldVisible } from "./isSensitiveDataFieldVisible";

export type SensitiveDataFieldValue = string | string[] | number | File | null;

export type SensitiveDataFormValues = Record<
  string,
  SensitiveDataFieldValue | boolean | ManualBankAccountValues
>;

export type SensitiveDataPayloadField = {
  field_key: string;
  field_value: SensitiveDataFieldValue;
};

const toFieldValue = (value: unknown): SensitiveDataFieldValue => {
  if (value === undefined || value === null) return null;
  if (Array.isArray(value)) return value;
  if (value instanceof File) return value;
  if (typeof value === "number") return value;
  if (typeof value === "boolean") return String(value);

  return String(value);
};

const isEmpty = (value: SensitiveDataFieldValue): boolean => {
  if (Array.isArray(value)) return value.length === 0;

  return value === null || value === "";
};

export const buildSensitiveDataPayload = (
  fields: SensitiveDataFormField[],
  valueByFieldKey: SensitiveDataFormValues
): SensitiveDataPayloadField[] =>
  fields
    .filter((field) => isSensitiveDataFieldVisible(field, valueByFieldKey))
    .map(({ field_key, is_encrypted }) => ({
      field_key,
      is_encrypted,
      field_value: toFieldValue(valueByFieldKey[field_key]),
    }))
    .filter(
      ({ is_encrypted, field_value }) => !is_encrypted || !isEmpty(field_value)
    )
    .map(({ field_key, field_value }) => ({ field_key, field_value }));
